import { FieldInputProps, useField } from "formik";
import * as React from "react";
import { NumericInput, NumericInputProps } from "../inputs";

type NumericFieldProps = NumericInputProps & Partial<FieldInputProps<any>>;

export const NumericField = (props: NumericFieldProps) => {
    const {
        name = props.id,
        checked,
        onChange,
        multiple,
        ...passThruProps
    } = props;
    const [field, meta] = useField(name);

    const handleChange = (e: React.ChangeEvent<any>) => {
        field.onChange(e);
        onChange?.(e);
    };

    const value =
        field.value === undefined || field.value === null ? "" : field.value;
    field.value = value;

    // remove onBlur, and onChange so that the NumericInput can handle
    const { onBlur, onChange: fieldOnChange, ...fieldProps } = field;

    return (
        <NumericInput
            {...passThruProps}
            {...fieldProps}
            type="tel"
            error={!!meta.error}
            helperText={meta.error}
            onChange={handleChange}
        />
    );
};
